import { jsx } from "react/jsx-runtime";
import React, { Children, cloneElement, forwardRef } from "react";
import { string, oneOf, oneOfType, arrayOf, node, bool } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Child nodes nested in list */
  children: oneOfType([
    arrayOf(node),
    node
  ]),
  /** Can be used to add classes to base UL element. */
  className: string,
  /** Sets id for this ListView and its children, must be unique. [Required] */
  id: string.isRequired,
  size: oneOf(["small", "medium", "large"]),
  showDivider: bool
};
const ListView = forwardRef((props, ref) => {
  const {
    children,
    prefix = "",
    id,
    className,
    size = "medium",
    showDivider = true,
    ...otherProps
  } = props;
  const classes = cx(
    `${prefix}list-view`,
    `${prefix}list-view--${size}`,
    className
  );
  return /* @__PURE__ */ jsx(
    "ul",
    {
      id,
      ref,
      role: "list",
      className: classes,
      ...otherProps,
      children: Children.map(children, (child, i) => child && cloneElement(child, {
        id: child.props.id ? child.props.id : `${prefix}${id}-${i}`,
        name: child.props.name ? child.props.name : `${prefix}${id}`,
        showDivider,
        size
      }))
    }
  );
});
ListView.propTypes = propTypes;
ListView.displayName = "ListView";
var ListView_default = ListView;
export {
  ListView_default as default
};
